<template>
    <div class="box-exportar">
        <div class="content-container row">
             <vue-excel-xlsx
                     :data="data"
                     :columns="columns"
                     :filename="filename"
                     :sheetname="sheetname">
                <i class="icon-download"></i>
                <span>EXPORTAR</span>
            </vue-excel-xlsx>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            data: Array,
            columns: Array,
            filename: String,
            sheetname: String,
        },
    };
</script>